import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductCarouselComponent } from '@sdvor/product/ui/v2';
import { BreadcrumbsComponent } from '@sdvor/seo/ui';
import { SdvorOrderConfirmationInfoModule } from '../../components/order-confirmation-info';

@Component({
  selector: 'sd-order-confirmation-page',
  imports: [BreadcrumbsComponent, SdvorOrderConfirmationInfoModule, ProductCarouselComponent],
  templateUrl: './order-confirmation-page.component.html',
  styleUrl: './order-confirmation-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderConfirmationPageComponent {}
